import { Manager } from "@levelapp/softfabric";
export default class StyleManager extends Manager {
    constructor() {
        super(...arguments);
        this.primaryColor = '#508ff4';
        this.textColor = '#a9afbb';
        this.activeTextColor = 'white';
        this.acceptButtonColor = '#28a745';
        this.cancelButtonColor = '#d83544';
        this.fontSize = 14;
        this.fontWeight = 'bold';
        this.fontFamily = "";
    }
}
